import Cookies from "js-cookie";

const DEFAULT_CHANNEL = "seer_kqcs_00001"; // 默认渠道

// 获取当前页面channel
export function getChannel() {
	// 检查是否在客户端环境
	if (typeof window === 'undefined' || typeof location === 'undefined') {
		return DEFAULT_CHANNEL;
	}
	
	const urlObj = new URL(location.href);

	let channel =
		urlObj.searchParams.get("channel") ||
		localStorage.getItem("channel") ||
		Cookies.get("_channel") ||
		DEFAULT_CHANNEL;

	// 避免channel为undefined
	if (channel == "undefined") {
		channel = DEFAULT_CHANNEL;
	}

	return channel;
}
